import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-deliverable" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "project-deliverable__label" }, "Asset type", -1 /* HOISTED */)
const _hoisted_3 = { class: "project-deliverable__content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "project-deliverable__label" }, "Qty", -1 /* HOISTED */)
const _hoisted_5 = { class: "project-deliverable__content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "project-deliverable__label" }, "Price/unit:", -1 /* HOISTED */)
const _hoisted_7 = { class: "project-deliverable__content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "project-deliverable__label" }, "Price per item:", -1 /* HOISTED */)
const _hoisted_9 = { class: "project-deliverable__content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "project-deliverable__label" }, "Total:", -1 /* HOISTED */)
const _hoisted_11 = { class: "project-deliverable__description" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "project-deliverable__label" }, "Description", -1 /* HOISTED */)
const _hoisted_13 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.deliverable.title), 1 /* TEXT */)
      ]),
      _createElementVNode("li", null, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.deliverable.quantity), 1 /* TEXT */)
      ]),
      _createElementVNode("li", null, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString($setup.price_per_unit), 1 /* TEXT */)
      ]),
      _createElementVNode("li", null, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString($setup.price_per_unit_after_discount) + " (after discount)", 1 /* TEXT */)
      ]),
      _createElementVNode("li", null, [
        _hoisted_10,
        _createElementVNode("span", {
          class: _normalizeClass(["project-deliverable__content", { 'project-deliverable__content--minus': $setup.total < 0 }])
        }, _toDisplayString($setup.total), 3 /* TEXT, CLASS */)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", {
        class: "project-deliverable__content",
        innerHTML: $props.deliverable.description
      }, null, 8 /* PROPS */, _hoisted_13)
    ])
  ]))
}